import type { FC } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { RobotOutlined } from '@ant-design/icons'
import LinearWithLabel from 'components/@extended/progress/LinearWithLabel'
import Paper from 'components/@extended/Paper'

interface ProcessingPanelProps {
  progress: number
}

const ProcessingPanel: FC<ProcessingPanelProps> = ({ progress }) => {
  return (
    <Paper sx={{ p: { xs: 3, md: 5 } }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        <Box
          sx={(theme) => ({
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.dark,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          })}
        >
          <RobotOutlined style={{ fontSize: 32 }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          AI analysis running
        </Typography>
        <Typography variant="body2" color="text.secondary">
          We are mapping categories, rewards, and suggested ordering. You can continue chatting while this runs.
        </Typography>
        <Box sx={{ width: '100%', maxWidth: 420 }}>
          <LinearWithLabel value={progress} />
        </Box>
      </Stack>
    </Paper>
  )
}

export default ProcessingPanel
